import URL from 'url-parse';
import {environment} from '../provider/authConfig'

export function getPlatformName() {
  return environment;
}

export function getPlatformDisplayName() {
  // if it's not prd for Production, change 'prd' to whatever is being used
  return (environment !== 'prd') ? ` - ${environment.toUpperCase()}` : '';
}



// WEBPACK FOOTER //
// ./src/utility/platform.js